export function toJsonDocument<T>(value: T): T {
  return JSON.parse(JSON.stringify(value)) as T;
}

export function canonicalJson(value: unknown): string {
  return JSON.stringify(value);
}

export function jsonEqual(a: unknown, b: unknown): boolean {
  return canonicalJson(a) === canonicalJson(b);
}
